import { api } from '../../DefaultService';
import {
  IStudentRecognitionEventProps,
  IStudentRecognitionEventSimpleProps,
} from './types';
import { IPaginationParams } from '../../types';

export const ENDPOINT_STUDENT = 'v1/events/recognitionStudent';

export const getStudentRecognitionEventByIdAsync = async (
  id: number,
): Promise<IStudentRecognitionEventProps> => {
  return await api
    .get(`${ENDPOINT_STUDENT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllStudentRecognitionEventByLicenseAsync = async (
  params: IPaginationParams,
): Promise<IStudentRecognitionEventSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT_STUDENT}/getAllByLicense`, {
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllStudentRecognitionEventCountByLicenseAsync =
  async (): Promise<number> => {
    return await api
      .get(`${ENDPOINT_STUDENT}/getAllByLicense/count`)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message || 'Erro interno do servidor!',
        );
      });
  };
